/* Keep the HeroDesk chat bubble off the add-to-cart row. (Nicolai, 2026-09-16)

   The launcher is a fixed 93x100 iframe pinned to the bottom-right corner, and the PDP's
   add-to-cart row puts the wishlist heart in exactly that corner - so at the scroll position
   you land on, the bubble sits on top of the heart.

   Rather than moving the bubble (it collides at SOME scroll position wherever it sits), fade it
   out only while the two actually overlap, and bring it straight back. Guarded on width so an
   OPEN chat panel is never hidden - the panel is much wider than the launcher. */
(function () {
  var LAUNCHER = '#herodesk-livechat';
  var ROWS = '.payment-buttons, .mobile-variant-sheet';
  var LAUNCHER_MAX_WIDTH = 160;
  var queued = false;

  function overlaps(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function check() {
    queued = false;
    var el = document.querySelector(LAUNCHER);
    if (!el) return;
    var a = el.getBoundingClientRect();
    if (!a.width || a.width > LAUNCHER_MAX_WIDTH) {   // chat is open - leave it alone
      el.classList.remove('cstm-chat-clear');
      return;
    }
    var hit = false;
    var rows = document.querySelectorAll(ROWS);
    for (var i = 0; i < rows.length; i++) {
      var b = rows[i].getBoundingClientRect();
      if (b.width && b.height && overlaps(a, b)) { hit = true; break; }
    }
    el.classList.toggle('cstm-chat-clear', hit);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    // rAF is suspended in a background tab, which would leave `queued` stuck on forever
    if (document.hidden) setTimeout(check, 50);
    else requestAnimationFrame(check);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);

  // the iframe is injected after load, so watch for it and re-check as it changes size
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
  });

  // the iframe is injected well after load and doesn't always mutate in a way the observer
  // sees, so re-check on a short timer for the first few seconds too
  var settle = setInterval(schedule, 500);
  setTimeout(function () { clearInterval(settle); }, 12000);

  schedule();
})();
